import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import { store } from '@/store/store.js'

import axios from 'axios';
import VueAxios from 'vue-axios';
const instance = axios.create({
	headers: {
		common: {
			authorization: ''
		}
	}
});


const encuestas = {
	state: {
		encuestas: [],
		encuesta: '',
		preguntasWithSaltos: [],
		encuestaFinalizada: false
	},
	getters: {
		getEncuestas: state => state.encuestas,
		getActualEncuesta: state => state.encuesta,
		getEncuestasObligatorias: state => {
			return state.encuestas.filter(e => e.respuestaObligatoria);
		},
		hasSaltos: state => {
			let has = false;
			if (!!state.encuesta) {
				state.encuesta.preguntas.forEach(p => {
					(p.respuestas.some(r => !!r.idPreguntaDestino)) ? has = true : null;
				})
			}

			return has;
		},
		getPreguntasSaltos: state => state.preguntasWithSaltos,
		getIsFinish: state => state.encuestaFinalizada
	},
	actions: {
		requestEncuestas: ({ commit, dispatch }, type) => {

			let url = (type == "Empresa") ? "/api/Empresa/dameEncuestas" : "/api/Alumno/dameEncuestasUsuario";

			return new Promise((resolve, reject) => {

				axios.get(url).then(r => {

					(r.data.status == 0) ? commit('setEncuestas', r.data.datos) : commit('setError', r.data.status);
					resolve(true);
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});


		},
		requestInfoOfEncuesta: ({ commit, dispatch, getters }, data) => {

			return new Promise((resolve, reject) => {

				console.log(data)

				instance.post(`${getters.getServer}/api/Encuestas/accesoEncuesta/${data.id}`, { "querystringValue": ((data.token) ? encodeURIComponent(data.token) : null) }).then(r => {


					if (r.data.status == 0) {

						if (!!r.data.datos.token) {

							window.sessionStorage.setItem('_tokenEncuesta', r.data.datos.token);

							let dataRequest = {
								id: data.id,
								token: r.data.datos.token,
								idPractica: r.data.datos.idPractica
							};


							dispatch('requestEncuesta', dataRequest);

							resolve(r.data.datos);

						} else {
							reject({
								canAnonimo: r.data.datos.sacaOpcionAnonima,
								needLogin: true,
								paraAlumnos: r.data.datos.paraAlumnos,
								paraEmpresa: r.data.datos.paraEmpresa,
								idPractica: r.data.datos.idPractica
							})
						}


					} else {
						commit('setError', r.data.status);
					}


				})
					.catch(function (error) {

						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestEncuesta: ({ commit, getters }, data) => {

			instance.defaults.headers.common['authorization'] = `Bearer ${data.token}`;

			instance.get(`${getters.getServer}/api/Encuestas/` + data.id).then(r => {
				if (r.data.status == 0) {
					r.data.datos.preguntas.forEach(p => p.error = false); //PARCHE PARA SETEAR VARIABLE ERROR
					commit('setEncuesta', r.data.datos)
				} else {
					commit('setError', r.data.status);
				}
			});
		},
		loginEncuesta: ({ commit, dispatch, getters }, data) => {

			return new Promise((resolve, reject) => {

				instance.post(`${getters.getServer}/api/Encuestas/logaUsuario/` + data.id, data.login).then(r => {

					let response = {
						"data": data,
						"r": r
					}

					dispatch('loggedEncuestaThings', response);

				});

			});

		},
		loginEncuestaSAML: ({ commit, dispatch }, data) => {
			return new Promise((resolve, reject) => {

				axios.post("api/Encuestas/validaRespuestaLoginIntegrado/" + data.id, { "respuesta": data.respuesta }).then(r => {

					let response = {
						"data": data,
						"r": r
					}

					dispatch('loggedEncuestaThings', response);

				})
					.catch(function (error) {
						commit('setError', 500);
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		dameEmpresasEncuesta: ({ commit, dispatch }, data) => {
			return new Promise((resolve, reject) => {

				axios.post("api/Empresa/dameEmpresasDelUsuario", data.login).then(response => {
					response = response.data;
					if (response.status == 0) {
						commit('savePass', data);
						if (response.datos.length > 1) {
							commit('setListaEmpresas', response.datos);
						} else {
							dispatch('sendEmpresaSeleccionadaEncuesta', response.datos[0].idEmpresa);
						}
					} else {
						if (response.status == 3) {
							commit('setErrorMensaje', response);
						} else {
							commit('setCompleteError', response);
						}
					}
				});

			});
		},
		sendEmpresaSeleccionadaEncuesta: ({ commit, dispatch, getters }, idEmpresa) => {

			let login = store.getters.getlogindata;

			let user = login.login;

			user.idEmpresa = idEmpresa;

			user.id = login.id;

			return new Promise((resolve, reject) => {

				instance.post(`${getters.getServer}/api/Encuestas/logaUsuario/` + user.id, user).then(r => {

					let response = {
						"data": user,
						"r": r
					}

					commit('removedataEmpresa');

					dispatch('loggedEncuestaThings', response);

				}).catch(function () {
					commit('removedataEmpresa');
				});

			});

		},
		loggedEncuestaThings: ({ commit, dispatch }, response) => {

			let data = response.data;
			let r = response.r;


			if (r.data.status == 0) {


				if (!!r.data.datos.token) {

					window.sessionStorage.setItem('_tokenEncuesta', r.data.datos.token);

					if (!!!r.data.datos.textoCortoRGPD) {

						let datatorequest = {
							id: data.id,
							token: r.data.datos.token
						};

						dispatch('requestEncuesta', datatorequest);

						commit('setError', '');

					} else {
						let dataRGPD = {
							text: r.data.datos.textoCortoRGPD,
							link: r.data.datos.linkExternoRGPD
						};
						commit('setRGPD', dataRGPD);
					}
				}

			} else {
				commit('setError', r.data.status);
			}

		},
		accesoAnonimo: ({ commit, dispatch, getters }, id) => {
			instance.post(`${getters.getServer}/api/Encuestas/logaAnonimo/` + id).then(r => {
				if (r.data.status == 0) {
					if (!!r.data.datos.token) {
						let data = { id: id, token: r.data.datos.token };
						dispatch('requestEncuesta', data);
					}
				} else {
					commit('setError', r.data.status);
				}
			});
		},
		sendEncuesta: ({ commit, dispatch, getters }, data) => {

			return new Promise((resolve, reject) => {



				instance.post(`${getters.getServer}/api/Encuestas/guardaContestacionEncuesta/${data.id}`, { "lContestaciones": data.value }).then(r => {
					if (r.data.status == 0) {
						resolve(true);
					} else {
						commit('setError', r.data.status);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});

		},
		getNextQuestion({ commit, dispatch }, data) {
			commit('setNextQuestion', data);
		},
		guardarRGPDEncuesta: ({ commit, dispatch, getters }, id) => {

			return new Promise((resolve, reject) => {

				let data = {
					id: id,
					token: window.sessionStorage.getItem('_tokenEncuesta')
				};

				instance.defaults.headers.common['authorization'] = `Bearer ${data.token}`;

				instance.get(`${getters.getServer}/api/Encuestas/guardaAceptacionRGPD`).then(response => {

					dispatch('requestEncuesta', data);

					commit('eraseTextRGPD');

					resolve(true)

				})
					.catch(function (error) {
						reject(false);
					});

			});


		}

	},
	mutations: {
		setEncuestas: function (state, data) {
			state.encuestas = data;
		},
		setEncuesta: function (state, data) {
			state.encuesta = data;
		},
		setNextQuestion: function (state, data) {
			let next;

			if (state.preguntasWithSaltos.length == 0) {
				//SI EL ARRAY ESTA VACIO, LO INICIALIZO
				next = state.encuesta.preguntas[0];
			} else {

				if (!!!data.to) {
					//SI NO TENGO DESTINO, SETEO LA SIGUIENTE PREGUNTA A LA ACTUAL COMO DESTINO
					let pos = state.encuesta.preguntas.findIndex(p => p.idPregunta == data.from);

					if (!!state.encuesta.preguntas[pos + 1]) {
						data.to = state.encuesta.preguntas[pos + 1].idPregunta;
					}

				}

				let posNextofNext = state.encuesta.preguntas.findIndex(p => p.idPregunta == data.to) + 1;


				if (posNextofNext == state.encuesta.preguntas.length) {
					state.encuestaFinalizada = true;
				}


				//SELECCIONO LA PREGUNTA DE DESTINO
				next = state.encuesta.preguntas.filter(p => p.idPregunta == data.to)[0];

				//SETEO LA PREGUNTA DE LA QUE PROVIENE
				(!!data.from) ? next.from = data.from : null;

			}

			//MIRO A VER SI YA HABIA ALGUNA PREGUNTA QUE YA PROCEDA DE LA ANTERIOR A LA QUE VOY A METER
			let replacePOS = state.preguntasWithSaltos.findIndex(p => p.from == next.from);

			//SI HAY LA REEMPLAZO EN SU POSICION Y SI NO, LA AÑADO A LA LISTA
			(replacePOS == -1) ? state.preguntasWithSaltos.push(next) : state.preguntasWithSaltos[replacePOS] = next;

		},
		removePreguntasSaltos: function (state) {
			state.preguntasWithSaltos = [Object.values(state.preguntasWithSaltos)[0]]
			state.encuestaFinalizada = false
		},
		
	}
}

export default encuestas;



// WEBPACK FOOTER //
// ./src/store/encuestas.js